import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const PersonalWrapper = styled.div`
  .password-placeholder > input {
    background-color: #F7F7F7;
  }
  &.user-access-modal{
    width: 100%!important;
  }
  .ant-modal-body{
    padding: 0;
  }
  .inputAable{
    color:#3F3F44;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  
  }
  .ant-input{
    border: none;
  }
  .ant-picker{
    &:hover{
      border-color: tranparent !important;
      box-shadow: none !important;
    }
    &.ant-picker-focused{
      border-color: #0B2A1B !important;
      box-shadow: none !important;
    }
  }
  .ant-form-item-control-input, .ant-select{
    &.ant-input{
      &:focus{
        border-color: #0B2A1B !important;
      }
    }
  }
  .ant-select-focused, .ant-input-affix-wrapper-focused{
    box-shadow: none !important;
  }
  .ant-select.ant-select-focused.workingRights .ant-select-selector{
    border-color: transparent !important;
    box-shadow: none !important;
    input{
      box-shadow: none !important;
      border-color: transparent !important;
    }
  }
  .ant-switch-checked{
    background-color : #0B2A1B !important;
  }
 .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;    
  }
  .form-title{
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3{
      font-size: 24px;
    }
  }
  .ant-form-item-control-input-content .inputFieldCstm{
    border: none;
    border-radius: 8px !important;
    background: #F7F7F7 !important;
    width: 100% !important;
    height: 56px !important;
  }
  .ant-form-item-control-input-content .inputFieldCstm:focus {
    border-color: #0B2A1B !important;
    box-shadow: none !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner  {
    border-color:
    #0B2A1B !important;
    background-color:
    #0B2A1B !important;
  }
  span.ant-checkbox-inner{
    border-color:
    #0B2A1B !important;
    background-color: white !important;
    
  }
height: normal !important;
  }
  .ant-picker.ant-picker-large {
    border-radius: 8px !important;
    background: #F7F7F7 !important;
    border: none !important;
    width: 100% !important;
    height: 56px !important;
}
.ant-select-selector{
  border-radius : 8px !important;
  border-color :#F7F7F7 !important;
  background: #F7F7F7 !important;

}
  .form-body{
    padding: 12px 24px 12px 24px;
    .checkbox-contact{
      margin-bottom: 10px;
    }
    .changePassword{
      padding : 10px 10px 10px 0px
      
    }
    .PassInfo{
      color: var(--Primary-Color, #0B2A1B);
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: normal;
    }
    .shareToCommunity{
      margin-bottom : 10px;
      color: var(--gray-700, #344054);
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 20px; /* 142.857% */
    }
    .contCheckBox{
      margin-left : 8px;
      color: var(--gray-700, #344054);
font-family: Inter;
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 20px; /* 166.667% */
    }
  }
  .profile-area{
    background-color:white;
    width:50%;
  }
  
  .uploadImg{
   margin: 40px 0px 40px 20px;
width: 170px;
height: 40px;
padding: 8px;
justify-content: center;
align-items: center;
gap: 10px;
border-radius:  8px !important;;
border-color :
#0B2A1B !important;
background: var(--Primary-Color,rgb(248, 14, 70));
color: white;
  }
  .uploadAvatar{
    margin: 40px 0px 40px 20px;
 width: 170px;
 height: 40px;
 padding: 8px;
 justify-content: center;
 align-items: center;
 gap: 10px;
 border-radius:  8px !important;;
 border-color : #0B2A1B !important;
 background: var(--Primary-Color,#0B2A1B);
 color: white;
   }
  .ant-select-selector .workingRights.{
    border: 1px solid #E2E8F0 !important;
  }
  .DltImg{
    margin: 40px 0px 40px 20px;
 width: 170px;
 display: flex;
width: 110px;
height: 40px;
padding: 8px;
justify-content: center;
align-items: center;
gap: 10px;
border-radius: 8px !important;
border: 1px solid #E2E8F0 !important;
background: var(--others-white, #FFF) !important;
   }
   .DltImg:hover{
    color:#0B2A1B !important;
    border-color :#0B2A1B !important;
   }
  .profile-image{
    width: 105px;
    height: 112px;
    flex-shrink: 0;
    border-radius: 112px;
background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  }

  /* Error field highlight animation */
  .field-error-highlight {
    animation: highlight 2s ease-in-out;
    border-radius: 8px;
  }
  
  @keyframes highlight {
    0% { box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.3); }
    50% { box-shadow: 0 0 0 10px rgba(255, 0, 0, 0); }
    100% { box-shadow: 0 0 0 0 rgba(255, 0, 0, 0); }
  }

  input:focus {
    box-shadow:rgb(248, 14, 70) !important; 
  }

  .phoneInput .ant-input-wrapper {
    height: 100%;
  }

  .phoneInput .ant-input, .phoneInput .ant-input-group-addon {
    border: none;
    background: none !important;
    height: 100%;
  }

  @media only screen and (width: 1024px) {
    .uploadAvatar{
      width:160px !important;
      margin: 60px 0px 30px 60px;
      
    }
    .uploadImg{
      width:140px !important;
      margin: 60px 0px 30px 10px;
      padding:0px;
      
    }
    .DltImg{
      margin: 60px 0px 30px 10px;
      width:120px !important;
    }
    .profile-image{
      margin-right:10px !important;

    }
  }

  @media only screen and (width: 768px) {
   
    .uploadAvatar{
      width:160px !important;
      margin: 60px 0px 30px 60px;
      
    }
    .uploadImg{
      width:140px !important;
      margin: 60px 0px 30px 10px;
      padding:0px;
      
    }
    .DltImg{
      margin: 60px 0px 30px 10px;
      width:100px !important;
    }
    .profile-image{
      margin-right:10px !important;
    
    }
  }
  @media only screen and (width: 425px) {
   
    
    .uploadAvatar{
      
      margin: 30px 0px 0px 0px;
      width: 280px;
    }
    .uploadImg{
      margin: 10px 0px 0px 0px;
      width: 280px;
      
    }
    .DltImg{
      margin: 10px 0px 0px 0px;
      width: 280px;
    }
    .profile-image{
      margin-left:60px;
    
    }
  }
  @media only screen and (width: 375px) {
    .form-title{
      padding: 16px 40px;
      border-bottom: 1px solid #eaeef1;
      h3{
        font-size: 24px;
      }
    }
    
    .uploadAvatar{
      
      margin: 30px 0px 0px 0px;
      width: 230px;
    }
    .uploadImg{
      margin: 10px 0px 0px 0px;
      width: 230px;
      
    }
    .DltImg{
      margin: 10px 0px 0px 0px;
      width: 230px;
    }
    .profile-image{
      margin-left:40px;
    
    }
  }
  @media only screen and (width: 320px) {
    padding-top:0px;
    .form-title{
      padding: 16px 40px;
      border-bottom: 1px solid #eaeef1;
      h3{
        font-size: 24px;
      }
    }
    
    .uploadAvatar{
      
      margin: 30px 0px 0px 0px;
      width: 190px;
    }
    .uploadImg{
      margin: 10px 0px 0px 0px;
      width: 190px;
      
    }
    .DltImg{
      margin: 10px 0px 0px 0px;
      width: 190px;
    }
    .profile-image{
      margin-left:15px;
    
    }
  }
 
  
`;

export default WithDirection(PersonalWrapper);